import Cookies from "js-cookie";
import { adminMainUrl, HRMSGOURL } from "../../../../Config";


//roles list
export const fetchRoleViewRequest = () => ({
    type: "FIND_ROLE_VIEW_REQUEST",
});

export const fetchRoleViewSuccess = (data) => ({
    type: "FIND_ROLE_VIEW_SUCCESS",
    payload: data,
});

export const fetchRoleViewFailure = (error) => ({
    type: "FIND_ROLE_VIEW_FAILURE",
    payload: error,
});

export const getRoleView = () => {
    return async function (dispatch) {
        const token = Cookies.get('token');

        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'Content-Type': 'application/json',
            }
        };

        // Append the page and items per page to the URL
        const apiUrl = `${adminMainUrl}/api/role-list-new`;

        await fetch(apiUrl, config)
            .then((res) => {
                res.json().then((resData) => {

                    console.log("this is resData of role access how does we access this think" , resData)
                    dispatch(fetchRoleViewSuccess(resData?.data));
                });
            }).catch((err) => {
                console.log("ERROR in getRoleView function(redux):", err);
            });
    };
};


//roles list